import Vue from "vue";
import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$lojas_formas_pgto = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      formas_pgto_loading: false,
      formas_pgto_button_loading: false,
      modalSelectStore: false,
      loja_selecionada: "",
      lojas_loading: false,
      loja_nome: "",
      formas_pagamento: [],
      addFormasPgto: false,
      addRules: false,
      actionType: "new", // "new" ou "edit
      ruleActionType: "new", // "new" ou "edit
      modosPgto: [],
      adquirentes: [],
      paymentForm: {
        idformaPag: null,
        order: null,
        description: null,
        internalDescription: null,
        paymentFormType: null,
        supportText: null,
        active: null,
        error: {
          order: [],
          description: [],
          internalDescription: [],
          paymentFormType: [],
          supportText: [],
        },
      },
      ruleForm: {
        idregra: null,
        order: null,
        active: null,
        description: null,
        adquirent: null,
        riskAnalysis: null,
        rules: [],
        softRules: [],
        idformaPag: null,
        error: {
          order: [],
          active: [],
          description: [],
          adquirent: [],
          riskAnalysis: [],
        },
      },
      modalRulesListOpen: false,
      rulesList: false,
      rulesDetailsOpen: false,
      regras_forma_pag: [],
    };
  },

  methods: {
    getLojaID() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin") {
        return this.$axios.getLocal("loja_usuario_selecionada").data;
      } else {
        return this.$axios.getLocal("oe_user_info")?.data?.loja;
      }
    },
    /**
     * @description Método para listar formas de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getFormasPgto(idloja) {
      this.formas_pgto_loading = true;
      if (idloja === "") {
        return;
      }
      this.$axios
        .get(this.ENDPOINTS.LISTAR_FORMAS_PAGAMENTO + idloja)
        .then(response => {
          if (response) {
            this.formas_pgto_button_loading = false;
            this.formas_pagamento = response;
            this.formas_pgto_loading = false;
            this.lojas_loading = false;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    /**
     * @description Método para listar os Modos de pagamento
     * @description Método para listar as regras da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getModosPgto(idloja) {
      this.$axios
        .get(
          this.ENDPOINTS.LISTAR_FORMAS_ACEITAS_FIRST +
            idloja +
            this.ENDPOINTS.LISTAR_FORMAS_ACEITAS_SECOND
        )
        .then(response => {
          if (response) {
            this.modosPgto = Object.values(response);
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    /**
     * @description Método para listar as regras da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getRegrasPgto(idloja, idforma_pag) {
      if (idloja === "" || idforma_pag === "") {
        return;
      }
      this.$axios
        .get(
          this.ENDPOINTS.LISTAR_REGRAS_PAGAMENTO_FIRST +
            idloja +
            "/" +
            idforma_pag +
            this.ENDPOINTS.LISTAR_REGRAS_PAGAMENTO_SECOND
        )
        .then(response => {
          if (response.error === 0) {
            this.regras_forma_pag = [];
            this.rulesList = true;
            return;
          }
          this.regras_forma_pag = response;
          this.rulesList = true;
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getAdquirentes(idloja) {
      this.$axios
        .get(
          this.ENDPOINTS.LISTAR_ADQUIRENTES_FIRST +
            idloja +
            this.ENDPOINTS.LISTAR_ADQUIRENTES_SECOND
        )
        .then(response => {
          if (response) {
            this.adquirentes = response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    getAnaliseDeRisco(idloja) {
      this.$axios
        .get(
          this.ENDPOINTS.LISTAR_ANALISE_RISCO_FIRST +
            idloja +
            this.ENDPOINTS.LISTAR_ANALISE_RISCO_SECOND
        )
        .then(response => {
          if (response) {
            this.analiseRisco = response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    /**
     * @description Método para cadastrar uma nova forma de pagamento
     * @param {Object} dados - Dados da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    async registerPaymentForm(idloja) {
      this.formas_pgto_button_loading = true;
      let dados = {
        ordem: this.paymentForm.order,
        dscforma_pag: this.paymentForm.description,
        dscinterna: this.paymentForm.internalDescription,
        texto_apoio: this.paymentForm.supportText,
        tipo: this.paymentForm.paymentFormType,
      };

      await this.$axios
        .post(this.ENDPOINTS.CADASTRAR_FORMA_PAGAMENTO + idloja, dados)
        .then(() => {
          this.formas_pgto_button_loading = false;
          this.cleanForm();
        })
        .catch(() => {
          this.formas_pgto_button_loading = false;
        })
        .finally(() => {
          this.addFormasPgto = false;
          this.getFormasPgto(idloja);
        });
    },
    /**
     * @description Método para alterar uma forma de pagamento
     * @param {Object} dados - Dados da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    editPaymentForm(idloja) {
      this.formas_pgto_button_loading = true;
      let dados = {
        ordem: this.paymentForm.order,
        dscforma_pag: this.paymentForm.description,
        dscinterna: this.paymentForm.internalDescription,
        texto_apoio: this.paymentForm.supportText,
        tipo: this.paymentForm.paymentFormType,
        ativo: this.paymentForm.active,
      };
      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_FORMA_PAGAMENTO +
            idloja +
            "/" +
            this.paymentForm.idformaPag,
          dados
        )
        .then(() => {
          this.formas_pgto_button_loading = false;
          this.cleanForm();
        })
        .catch(error => {
          this.formas_pgto_button_loading = false;
          throw new Error(error);
        })
        .finally(() => {
          this.addFormasPgto = false;
          this.getFormasPgto(idloja);
        });
    },
    registerRule(idloja, idforma_pag) {
      let dados = {
        dscregra: this.ruleForm.description,
        idadquirente: this.ruleForm.adquirent,
        idanalise_risco: this.ruleForm.riskAnalysis,
        ordem: this.ruleForm.order,
        regras: new Set(this.ruleForm.rules),
      };

      if (
        this.ruleForm.riskAnalysis === "" ||
        this.ruleForm.riskAnalysis === null ||
        this.ruleForm.riskAnalysis === undefined
      ) {
        delete dados.idanalise_risco;
      }

      this.$axios
        .post(
          `${this.ENDPOINTS.CADASTRAR_REGRA_PAGAMENTO_FIRST}${idloja}/${idforma_pag}${this.ENDPOINTS.CADASTRAR_REGRA_PAGAMENTO_SECOND}`,
          dados
        )
        .then(() => {
          this.cleanRule();
          this.addRules = false;
          this.getRegrasPgto(idloja, idforma_pag);
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    editRule(idloja, idforma_pag) {
      let regras = {};
      this.ruleForm.rules.forEach((regra, index) => {
        regras[index] = regra;
      });

      let dados = {
        dscregra: this.ruleForm.description,
        idadquirente: this.ruleForm.adquirent,
        idanalise_risco: this.ruleForm.riskAnalysis,
        ordem: this.ruleForm.order,
        regras,
        ativo: 1,
      };

      if (
        this.ruleForm.riskAnalysis === "" ||
        this.ruleForm.riskAnalysis === null ||
        this.ruleForm.riskAnalysis === undefined
      ) {
        delete dados.idanalise_risco;
      }

      this.$axios
        .put(
          `${this.ENDPOINTS.ALTERAR_REGRA_PAGAMENTO_FIRST}${idloja}/${idforma_pag}${this.ENDPOINTS.ALTERAR_REGRA_PAGAMENTO_SECOND}${this.ruleForm.idregra}`,
          dados
        )
        .then(() => {
          this.cleanRule();
          this.addRules = false;
          this.rulesDetailsOpen = false;
          this.getRegrasPgto(idloja, idforma_pag);
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    /**
     * @description Método para validar os campos do formulário de cadastro/alteração de uma forma de pagamento
     * @param {String} idloja - ID da loja
     * @param {String} formas_pgto_AddEdit - Tipo de cadastro (new ou edit)
     * @returns {Function} Retorna uma função alterarFormaPgto ou cadastrarFormaPgto
     */
    async validarCadastro(idloja) {
      if (this.paymentForm.order == "") {
        this.$config.alert(
          "Preencha a ordem corretamente!",
          this.$config.dados.errorColor
        );
        this.paymentForm.error.order = "Preencha a ordem corretamente!";
        return;
      }

      if (this.paymentForm.description == "") {
        this.$config.alert(
          "Preencha a descrição corretamente!",
          this.$config.dados.errorColor
        );
        this.paymentForm.error.description =
          "Preencha a descrição corretamente!";
        return;
      }

      if (this.paymentForm.paymentFormType == "") {
        this.$config.alert(
          "Selecione o tipo da forma de pagamento!",
          this.$config.dados.errorColor
        );
        this.paymentForm.error.paymentFormType =
          "Selecione o tipo da forma de pagamento!";
        return;
      }

      if (this.actionType == "edit") {
        this.editPaymentForm(idloja);
        return;
      }

      this.registerPaymentForm(idloja);
    },
    /**
     * @description Método para validar os campos do formulário de cadastro/alteração de uma regra de forma de pagamento
     * @param {String} idloja - ID da loja
     * @param {String} formas_pgto_AddEdit - Tipo de cadastro (new ou edit)
     * @returns {Function} Retorna uma função alterarFormaPgto ou cadastrarFormaPgto
     */
    validateRuleRegister(idloja, idforma_pag) {
      if (this.ruleForm.order == "") {
        this.$config.alert(
          "Preencha a ordem corretamente!",
          this.$config.dados.errorColor
        );
        this.ruleForm.error.order = "Preencha a ordem corretamente!";
        return;
      }

      if (this.ruleForm.description == "") {
        this.$config.alert(
          "Preencha a descrição corretamente!",
          this.$config.dados.errorColor
        );
        this.ruleForm.error.description = "Preencha a descrição corretamente!";
        return;
      }

      if (this.ruleForm.adquirent == "") {
        this.$config.alert(
          "Selecione a adquirente!",
          this.$config.dados.errorColor
        );
        this.ruleForm.error.adquirent = "Selecione a adquirente!";
        return;
      }

      if (this.ruleActionType === "edit") {
        this.editRule(idloja, idforma_pag);
        return;
      }

      this.registerRule(idloja, idforma_pag);
    },
    cleanForm() {
      this.paymentForm.order = "";
      this.paymentForm.description = "";
      this.paymentForm.internalDescription = "";
      this.paymentForm.paymentFormType = "";
      this.paymentForm.supportText = "";
      this.paymentForm.error.order = [];
      this.paymentForm.error.description = [];
      this.paymentForm.error.internalDescription = [];
      this.paymentForm.error.paymentFormType = [];
    },
    cleanRule() {
      this.ruleForm.order = "";
      this.ruleForm.description = "";
      this.ruleForm.adquirent = "";
      this.ruleForm.riskAnalysis = "";
    },
  },
});
